module.exports = __webpack_public_path__ + "static/media/engagement.17d79c2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/engagement.svg
// module id = 699
// module chunks = 0